/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordId } from "../../commons/types/RecordId";
import { Resolve } from "./Resolve";
export const ResolvedRecords = core.serialization.object({
    recordId: RecordId,
    resolves: core.serialization.list(Resolve),
});
